import api from "./api";
import config from "../config";

export default {
  fetchAllForPerson(apiKey, person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/${person}/notes`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.notes);
        }
      );
    });
  },

  fetchAllForOrder(apiKey, order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `orders/${order}/notes`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.notes);
        }
      );
    });
  },

  fetchOne(apiKey, note) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `notes/${note}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(apiKey, note, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `notes/${note}`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, note) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `notes/${note}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `notes`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/NoteUtil.js